import { useRouter } from "next/router"

import { consumeHook } from "@/lib/consume/hook"

export const consumeUseRouter = (...hookArgs: Parameters<typeof useRouter>) => {
  return consumeHook({
    getHookArguments: () => {
      return hookArgs
    },
    hook: useRouter,
    provideTo: `router`,
  })
}
